var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.652,
    height: 39.439,
    viewBox: "0 0 33.652 39.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building_1_",
    "data-name": "building (1)",
    transform: "translate(-37.8 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65350",
    "data-name": "Path 65350",
    d: "M272.7,105.35h3.5a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.761.761,0,0,0-.761.761v3.509A.761.761,0,0,0,272.7,105.35Zm.761-3.509h1.982v1.988h-1.982Z",
    transform: "translate(-216.103 -92.69)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65351",
    "data-name": "Path 65351",
    d: "M181.973,105.35h3.5a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.76.76,0,0,0-.761.761v3.509A.761.761,0,0,0,181.973,105.35Zm.761-3.509h1.982v1.988h-1.982Z",
    transform: "translate(-132.274 -92.69)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65352",
    "data-name": "Path 65352",
    d: "M272.7,206.93h3.5a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.761.761,0,0,0-.761.761v3.509A.761.761,0,0,0,272.7,206.93Zm.761-3.509h1.982v1.988h-1.982Z",
    transform: "translate(-216.103 -186.545)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65353",
    "data-name": "Path 65353",
    d: "M181.973,206.93h3.5a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.761.761,0,0,0-.761.761v3.509A.761.761,0,0,0,181.973,206.93Zm.761-3.509h1.982v1.988h-1.982Z",
    transform: "translate(-132.274 -186.545)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65354",
    "data-name": "Path 65354",
    d: "M272.7,308.507h3.5a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.761.761,0,0,0-.761.761v3.509A.761.761,0,0,0,272.7,308.507Zm.761-3.509h1.982v1.988h-1.982Z",
    transform: "translate(-216.103 -280.397)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65355",
    "data-name": "Path 65355",
    d: "M185.476,308.507a.761.761,0,0,0,.761-.761v-3.509a.761.761,0,0,0-.761-.761h-3.5a.76.76,0,0,0-.761.761v3.509a.761.761,0,0,0,.761.761ZM182.733,305h1.982v1.988h-1.982Z",
    transform: "translate(-132.274 -280.397)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65356",
    "data-name": "Path 65356",
    d: "M70.441,37.418h-.707V14.446a.761.761,0,0,0-.761-.761H64.018V4.256a.761.761,0,0,0-.761-.761h-1.62V.761A.761.761,0,0,0,60.877,0H48.924a.761.761,0,0,0-.761.761V3.5h-1.62a.761.761,0,0,0-.761.761V18.893H41.61a.761.761,0,0,0-.761.761V37.418H38.811a.761.761,0,0,0,0,1.521H70.441a.761.761,0,1,0,0-1.521ZM49.684,1.521H60.116V3.5H49.684ZM42.37,20.414h3.412v17H42.37ZM47.3,5.016H62.5v32.4H58.711V32.4a.761.761,0,0,0-.761-.761h-6.1a.761.761,0,0,0-.761.761v5.018H47.3Zm5.307,32.4V33.161h4.58v4.257Zm11.408,0V15.207h4.194V37.418Z",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.5d8f6fa7590b86772076b3e7fa7c6191.svg";
export { ForwardRef as ReactComponent };